// @flow
import {
  formatDateDisplayLocal,
  formatTimeDisplayLocal,
  toMoment,
} from '@fortress-technology-solutions/fortress-component-library/utils';
import messages from './messages';

type Intl = { formatMessage: Function };

/** "Last saved today at 2:14 PM", "… yesterday at …", or with the date; null when never saved. */
export const formatLastSaved = (
  savedAt: ?string,
  intl: Intl,
  now: Date | string = new Date(),
): ?string => {
  // toMoment returns null (not an invalid moment) for unparseable input.
  const parsed = savedAt ? toMoment(savedAt) : null;
  if (!parsed || !parsed.isValid()) return null;
  // toMoment keeps "Z" timestamps in UTC mode; compare calendar days in the viewer's zone.
  const saved = parsed.local();
  const today = toMoment(now).local();
  const time = formatTimeDisplayLocal(savedAt, 'h:mm A');
  if (saved.isSame(today, 'day')) {
    return intl.formatMessage(messages.lastSavedToday, { time });
  }
  if (saved.isSame(today.clone().subtract(1, 'day'), 'day')) {
    return intl.formatMessage(messages.lastSavedYesterday, { time });
  }
  return intl.formatMessage(messages.lastSavedOn, {
    date: formatDateDisplayLocal(savedAt, 'MM/DD/YYYY'),
    time,
  });
};
